import React from "react";
import { Box, Typography, Avatar, AvatarGroup } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import GroupIcon from "@mui/icons-material/Group";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CommonButton from "../../ui/inputs/CommonButton";

const GlobalCommunityUI = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        alignItems: "center",
        px: { xs: 4, md: 10 },
        py: { xs: 4, md: 0 },
        boxSizing: "border-box",
        zIndex: 10,
        pointerEvents: "none", // Let scroll pass through if needed
      }}
    >
      {/* LEFT SIDE CONTENT */}
      <Box 
        sx={{ 
          maxWidth: "500px", 
          pointerEvents: "auto",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "0.15em",
            color: "rgba(255,255,255,0.6)",
            mb: 2.5,
            textTransform: "uppercase",
            textShadow: "0 2px 10px rgba(0,0,0,0.5)",
          }}
        >
          GLOBAL COMMUNITY
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "2.5rem", md: "3.5rem" },
            fontWeight: 800,
            color: "#ffffff",
            lineHeight: 1.1,
            mb: 3,
            textShadow: "0 4px 20px rgba(0,0,0,0.6)",
          }}
        >
          Played in 150+<br />Countries
        </Typography>

        <Typography
          sx={{
            fontSize: "1.1rem",
            color: "rgba(255,255,255,0.8)",
            lineHeight: 1.6,
            mb: 5,
            maxWidth: "450px",
            textShadow: "0 2px 10px rgba(0,0,0,0.5)",
          }}
        >
          Join a growing community of players worldwide. AutoBET is borderless,
          accessible and built for everyone.
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
          <CommonButton variant="primary" size="large" sx={{ borderRadius: "12px", px: 4, py: 1.5, fontSize: "1rem" }}>
            Join Now
          </CommonButton>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <AvatarGroup 
              max={4} 
              sx={{ 
                "& .MuiAvatar-root": { 
                  width: 36, 
                  height: 36, 
                  borderColor: "#050914",
                  borderWidth: 2
                } 
              }}
            >
              <Avatar sx={{ bgcolor: "#3b82f6" }} />
              <Avatar sx={{ bgcolor: "#ef4444" }} />
              <Avatar sx={{ bgcolor: "#10b981" }} />
              <Avatar sx={{ bgcolor: "#8b5cf6" }} />
            </AvatarGroup>

            <Typography sx={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.7)", fontWeight: 600, textShadow: "0 2px 10px rgba(0,0,0,0.5)" }}>
              +482K Players
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* RIGHT SIDE STATS */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4, pointerEvents: "auto" }}>
        
        {/* Stat 1 */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.05)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(10px)",
            }}
          >
            <LanguageIcon sx={{ color: "rgba(255,255,255,0.8)", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, color: "#ffffff", lineHeight: 1.2 }}>
              150+
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)", fontWeight: 500 }}>
              Countries
            </Typography>
          </Box>
        </Box>

        {/* Stat 2 */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.05)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(10px)",
            }}
          >
            <GroupIcon sx={{ color: "rgba(255,255,255,0.8)", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, color: "#ffffff", lineHeight: 1.2 }}>
              482K+
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)", fontWeight: 500 }}>
              Players
            </Typography>
          </Box>
        </Box>

        {/* Stat 3 */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.05)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(10px)",
            }}
          >
            <EmojiEventsIcon sx={{ color: "rgba(255,255,255,0.8)", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, color: "#ffffff", lineHeight: 1.2 }}>
              $24.9M+
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)", fontWeight: 500 }}>
              Total Winnings
            </Typography>
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default GlobalCommunityUI;